/******/ (() => { // webpackBootstrap
var __webpack_exports__ = {};
window.PXUTheme.jsCart = {
  init: function ($section) {
    this.$section = $section;
    this.namespace = '.jsCartV2';
    this.mobileCheckoutObserver = null;
    this.mobileHandoffListener = null;
    this.affirmCartPromoObserver = null;
    this.affirmCartPromoBlock = null;
    this.lastCartState = null;
    this.lastViewCartSignature = null;
    this.skipNextStandardCheckout = false;
    this.bindEvents();
    this.collapseMobileDefaults();
    this.updateStickyOffset();
    const self = this;
    window.requestAnimationFrame(function () {
      self.updateStickyOffset();
    });
    window.setTimeout(function () {
      self.updateStickyOffset();
    }, 250);
    this.syncMobileTotal();
    this.updateSummaryStickyMode();
    this.setupMobileCheckoutHandoff();
    this.setupAffirmCartPromo();
    this.saveDispatchEtaAttributes();
    this.refreshCartSnapshot({ trackView: true });
  },
  bindEvents: function () {
    const self = this;

    $(document).off('click' + this.namespace, '[data-cart-page-delete]');
    $(document).on('click' + this.namespace, '[data-cart-page-delete]', function (e) {
      e.preventDefault();
      const lineID = $(this).data('line-item-key');
      self.removeFromCart(lineID);
      return false;
    });

    $(document).off('click' + this.namespace, '[data-cart-v2-toggle]');
    $(document).on('click' + this.namespace, '[data-cart-v2-toggle]', function (e) {
      e.preventDefault();
      self.togglePanel($(this));
    });

    $(document).off('click' + this.namespace, '[data-cart-upsell-add]');
    $(document).on('click' + this.namespace, '[data-cart-upsell-add]', function (e) {
      e.preventDefault();
      self.addUpsell($(this));
    });

    $(document).off('click' + this.namespace, '[data-cart-upsell-update]');
    $(document).on('click' + this.namespace, '[data-cart-upsell-update]', function (e) {
      e.preventDefault();
      self.updateUpsell($(this));
    });

    $(document).off('click' + this.namespace, '[data-cart-upsell-remove]');
    $(document).on('click' + this.namespace, '[data-cart-upsell-remove]', function (e) {
      e.preventDefault();
      const lineID = $(this).data('line-item-key');
      if (!lineID) {
        return;
      }
      self.removeFromCart(lineID);
    });

    $(document).off('click' + this.namespace, '[data-cart-copy-link]');
    $(document).on('click' + this.namespace, '[data-cart-copy-link]', function (e) {
      e.preventDefault();
      const $link = $(this);
      const url = $link.attr('data-cart-copy-link-value') || $link.attr('href');
      if (!url) {
        return;
      }
      self.copyCartLink(url, $link, {
        copiedLabel: 'Link copied!',
        onSuccess: function () {
          if ($link.closest('[data-cart-share-fallback]').length > 0) {
            self.hideShareFallback();
          }
        }
      });
    });

    $(document).off('click' + this.namespace, '[data-cart-top-share]');
    $(document).on('click' + this.namespace, '[data-cart-top-share]', function (e) {
      e.preventDefault();
      self.handleTopShare($(this));
    });

    $(document).off('click' + this.namespace, '[data-cart-share-shell]');
    $(document).on('click' + this.namespace, '[data-cart-share-shell]', function (e) {
      e.stopPropagation();
    });

    $(document).off('click' + this.namespace + 'ShareClose');
    $(document).on('click' + this.namespace + 'ShareClose', function () {
      self.hideShareFallback();
    });

    $(document).off('change' + this.namespace, '[data-cart-tos]');
    $(document).on('change' + this.namespace, '[data-cart-tos]', function () {
      self.clearTosError($('#cart_form'));
    });

    $(document).off('change' + this.namespace, '[data-dispatch-eta-state]');
    $(document).on('change' + this.namespace, '[data-dispatch-eta-state]', function () {
      self.saveDispatchEtaAttributes();
    });

    $(document).off('submit' + this.namespace, '#cart_form');
    $(document).on('submit' + this.namespace, '#cart_form', function (e) {
      const $form = $(this);
      self.saveDispatchEtaAttributes();
      if (!self.validateTos($form)) {
        e.preventDefault();
        return false;
      }

      if (self.skipNextStandardCheckout) {
        self.skipNextStandardCheckout = false;
        return true;
      }

      self.trackBeginCheckout('standard', 'secure_checkout');
      return true;
    });

    $(document).off('click' + this.namespace, '.cart-v2-additional-checkout-buttons button, .cart-v2-additional-checkout-buttons [role="button"], .cart-v2-additional-checkout-buttons a');
    $(document).on('click' + this.namespace, '.cart-v2-additional-checkout-buttons button, .cart-v2-additional-checkout-buttons [role="button"], .cart-v2-additional-checkout-buttons a', function (e) {
      const $form = $('#cart_form');
      if (!self.validateTos($form)) {
        e.preventDefault();
        e.stopImmediatePropagation();
        return false;
      }

      const provider = self.detectExpressProvider($(this));
      self.skipNextStandardCheckout = true;
      self.trackExpressCheckout(provider);
      self.trackBeginCheckout('express', provider);
      return true;
    });

    // Prevent cart form submission when pressing Enter in quantity/notes fields.
    $(document).off('keydown' + this.namespace, '#cart_form');
    $(document).on('keydown' + this.namespace, '#cart_form', function (e) {
      if (e.keyCode === 13) {
        e.preventDefault();
        return false;
      }
      return true;
    });

    $(window).off('resize' + this.namespace);
    $(window).on('resize' + this.namespace, function () {
      self.collapseMobileDefaults();
      self.updateStickyOffset();
      self.updateSummaryStickyMode();
      self.setupMobileCheckoutHandoff();
      self.rehomeAffirmCartPromo();
    });
  },
  getAffirmCartPromoBlock: function () {
    const appBlock = document.querySelector('[id*="affirm_pay_over_time_messaging_cart_block"]');
    if (appBlock) {
      this.affirmCartPromoBlock = appBlock;
      return appBlock;
    }

    const affirmText = document.querySelector('.affirm-as-low-as');
    if (!affirmText) {
      return this.affirmCartPromoBlock;
    }

    const block = affirmText.closest('.shopify-app-block') || affirmText.parentElement;
    this.affirmCartPromoBlock = block;
    return block;
  },
  rehomeAffirmCartPromo: function () {
    const target = document.querySelector('[data-cart-v2-affirm-target]');
    const block = this.getAffirmCartPromoBlock();

    if (!target || !block || target.contains(block)) {
      return;
    }

    const sourceSection = block.closest('.shopify-section');
    target.appendChild(block);

    if (sourceSection && !target.contains(sourceSection)) {
      sourceSection.style.display = 'none';
      sourceSection.setAttribute('aria-hidden', 'true');
    }
  },
  setupAffirmCartPromo: function () {
    const self = this;

    if (this.affirmCartPromoObserver && typeof this.affirmCartPromoObserver.disconnect === 'function') {
      this.affirmCartPromoObserver.disconnect();
      this.affirmCartPromoObserver = null;
    }

    this.rehomeAffirmCartPromo();
    window.setTimeout(function () { self.rehomeAffirmCartPromo(); }, 500);
    window.setTimeout(function () { self.rehomeAffirmCartPromo(); }, 1500);
    window.setTimeout(function () { self.rehomeAffirmCartPromo(); }, 3500);

    if (!document.body || !('MutationObserver' in window)) {
      return;
    }

    this.affirmCartPromoObserver = new MutationObserver(function () {
      self.rehomeAffirmCartPromo();
    });
    this.affirmCartPromoObserver.observe(document.body, {
      childList: true,
      subtree: true
    });
  },
  updateStickyOffset: function () {
    const sectionEl = this.$section && this.$section.length ? this.$section[0] : null;
    if (!sectionEl) {
      return;
    }

    if (window.innerWidth <= 798) {
      sectionEl.style.setProperty('--cart-v2-sticky-top', '20px');
      return;
    }

    const selectors = [
      '#shopify-section-announcement-bar',
      '.announcement-bar',
      '[data-announcement-bar]',
      '#shopify-section-header',
      '.header-section',
      '.header-wrapper',
      '.site-header',
      'header[role="banner"]'
    ];

    const seen = new Set();
    const candidates = [];
    selectors.forEach(function (selector) {
      document.querySelectorAll(selector).forEach(function (node) {
        if (!seen.has(node)) {
          seen.add(node);
          candidates.push(node);
        }
      });
    });

    let maxBottom = 0;
    candidates.forEach(function (node) {
      const style = window.getComputedStyle(node);
      if (style.display === 'none' || style.visibility === 'hidden') {
        return;
      }

      const isStickyLike = style.position === 'fixed' || style.position === 'sticky';
      if (!isStickyLike) {
        return;
      }

      const rect = node.getBoundingClientRect();
      if (rect.bottom <= 0 || rect.top > 140) {
        return;
      }

      maxBottom = Math.max(maxBottom, rect.bottom);
    });

    const topOffset = Math.max(20, Math.round(maxBottom + 12));
    sectionEl.style.setProperty('--cart-v2-sticky-top', topOffset + 'px');
  },
  updateSummaryStickyMode: function () {
    $('.cart-v2-sidebar').removeClass('is-static');
    $('.cart-v2-summary').removeClass('is-static');
  },
  setupMobileCheckoutHandoff: function () {
    if (this.mobileCheckoutObserver && typeof this.mobileCheckoutObserver.disconnect === 'function') {
      this.mobileCheckoutObserver.disconnect();
      this.mobileCheckoutObserver = null;
    }
    if (this.mobileHandoffListener) {
      window.removeEventListener('scroll', this.mobileHandoffListener);
      window.removeEventListener('orientationchange', this.mobileHandoffListener);
      this.mobileHandoffListener = null;
    }

    const stickyBar = document.querySelector('.cart-v2-mobile-bar');
    const summaryCheckout = document.querySelector('.cart-v2-summary .cart-v2-checkout:not(.cart-v2-mobile-checkout)');
    if (!stickyBar) {
      return;
    }

    const evaluateHandoff = function () {
      if (window.innerWidth > 798 || !summaryCheckout) {
        stickyBar.classList.remove('is-handoff-hidden');
        return;
      }

      const rect = summaryCheckout.getBoundingClientRect();
      const viewportHeight = window.innerHeight || document.documentElement.clientHeight;
      const isVisible = rect.top < (viewportHeight - 56) && rect.bottom > 56;
      stickyBar.classList.toggle('is-handoff-hidden', isVisible);
    };

    evaluateHandoff();
    if (window.innerWidth > 798 || !summaryCheckout || !('IntersectionObserver' in window)) {
      return;
    }

    this.mobileCheckoutObserver = new IntersectionObserver((entries) => {
      const entry = entries[0];
      if (!entry) {
        evaluateHandoff();
        return;
      }

      stickyBar.classList.toggle('is-handoff-hidden', entry.isIntersecting);
    }, {
      root: null,
      rootMargin: '0px 0px -56px 0px',
      threshold: [0, 0.15, 0.35, 1]
    });

    this.mobileCheckoutObserver.observe(summaryCheckout);

    let ticking = false;
    this.mobileHandoffListener = function () {
      if (ticking) {
        return;
      }
      ticking = true;
      window.requestAnimationFrame(function () {
        ticking = false;
        evaluateHandoff();
      });
    };
    window.addEventListener('scroll', this.mobileHandoffListener, { passive: true });
    window.addEventListener('orientationchange', this.mobileHandoffListener);
  },
  setPanelState: function ($trigger, nextExpanded) {
    if (!$trigger || $trigger.length < 1) {
      return;
    }

    const targetId = $trigger.attr('data-target');
    if (!targetId) {
      return;
    }

    const $target = $('#' + targetId);
    if ($target.length < 1) {
      return;
    }

    $trigger.attr('aria-expanded', String(nextExpanded));
    $target.toggleClass('is-open', nextExpanded);
    $target.toggleClass('cart-v2-hidden', !nextExpanded);
    $target.attr('aria-hidden', String(!nextExpanded));

    if ($trigger.hasClass('cart-v2-inclusions-toggle')) {
      $trigger.toggleClass('is-open', nextExpanded);
    } else {
      const $label = $trigger.find('[data-toggle-label]').first();
      const expandedLabel = $trigger.attr('data-expanded-label');
      const collapsedLabel = $trigger.attr('data-collapsed-label');
      if ($label.length > 0 && (expandedLabel || collapsedLabel)) {
        $label.text(nextExpanded ? (expandedLabel || $label.text()) : (collapsedLabel || $label.text()));
      }
      const $icon = $trigger.find('[aria-hidden="true"]').last();
      if ($icon.length > 0) {
        $icon.text(nextExpanded ? '-' : '+');
      }
    }
  },
  togglePanel: function ($trigger) {
    const isExpanded = $trigger.attr('aria-expanded') === 'true';
    const nextExpanded = !isExpanded;
    this.setPanelState($trigger, nextExpanded);
    this.updateSummaryStickyMode();
  },
  collapseMobileDefaults: function () {
    if (window.innerWidth > 798) {
      const self = this;
      $('[data-cart-v2-root]').each(function () {
        const $root = $(this);
        $root.find('.cart-v2-upsells-toggle').each(function () {
          self.setPanelState($(this), true);
        });
      });
      return;
    }

    const self = this;
    $('[data-cart-v2-root]').each(function () {
      const $root = $(this);

      $root.find('.cart-v2-inclusions-toggle').each(function () {
        self.setPanelState($(this), false);
      });

      $root.find('.cart-v2-upsells-toggle').each(function () {
        self.setPanelState($(this), false);
      });
    });
  },
  copyCartLink: function (url, $link, options) {
    if (!url) {
      return;
    }

    const originalHtml = $link.html();
    const copyOptions = options || {};
    const copiedLabel = copyOptions.copiedLabel || 'Link copied!';
    const finish = () => {
      $link.text(copiedLabel);
      setTimeout(() => {
        $link.html(originalHtml);
      }, 2000);
      if (typeof copyOptions.onSuccess === 'function') {
        copyOptions.onSuccess();
      }
    };

    if (navigator && navigator.clipboard && typeof navigator.clipboard.writeText === 'function') {
      navigator.clipboard.writeText(url).then(finish).catch(() => {
        const copied = this.fallbackCopyText(url, finish);
        if (!copied) {
          if (typeof copyOptions.onFail === 'function') {
            copyOptions.onFail();
          } else {
            this.promptCopyText(url);
          }
        }
      });
      return;
    }

    const copied = this.fallbackCopyText(url, finish);
    if (!copied) {
      if (typeof copyOptions.onFail === 'function') {
        copyOptions.onFail();
      } else {
        this.promptCopyText(url);
      }
    }
  },
  handleTopShare: function ($trigger) {
    if (!$trigger || $trigger.length < 1) {
      return;
    }

    const shareUrl = $trigger.attr('data-cart-share-url') || window.location.href;
    const self = this;
    const copyWithFeedback = function () {
      self.copyCartLink(shareUrl, $trigger, {
        copiedLabel: 'Link copied!',
        onSuccess: function () {
          self.hideShareFallback();
        },
        onFail: function () {
          self.showShareFallback($trigger, shareUrl);
        }
      });
    };

    if (navigator && typeof navigator.share === 'function') {
      navigator.share({
        title: document.title || 'Growplay Cart',
        text: 'Growplay cart',
        url: shareUrl
      }).catch(() => {
        copyWithFeedback();
      });
      return;
    }

    copyWithFeedback();
  },
  showShareFallback: function ($trigger, shareUrl) {
    const $shell = $trigger.closest('[data-cart-share-shell]');
    const $fallback = $shell.find('[data-cart-share-fallback]');
    if ($fallback.length < 1) {
      this.promptCopyText(shareUrl);
      return;
    }

    $fallback.find('[data-cart-copy-link]').attr('data-cart-copy-link-value', shareUrl);
    $fallback.find('.cart-v2-share-fallback-url').val(shareUrl);
    $fallback.removeClass('cart-v2-hidden');
  },
  hideShareFallback: function () {
    $('[data-cart-share-fallback]').addClass('cart-v2-hidden');
  },
  fallbackCopyText: function (text, onSuccess) {
    const textarea = document.createElement('textarea');
    textarea.value = text;
    textarea.setAttribute('readonly', '');
    textarea.style.position = 'absolute';
    textarea.style.left = '-9999px';
    document.body.appendChild(textarea);
    textarea.select();
    let copied = false;
    try {
      copied = document.execCommand('copy');
      if (copied && typeof onSuccess === 'function') {
        onSuccess();
      }
    } catch (err) {
      copied = false;
    }
    document.body.removeChild(textarea);
    return copied;
  },
  promptCopyText: function (text) {
    if (typeof window.prompt === 'function') {
      window.prompt('Copy cart link:', text);
    }
  },
  validateTos: function ($form) {
    if (!$form || $form.length < 1) {
      return true;
    }

    const $checkbox = $form.find('[data-cart-tos]');
    const $error = $form.find('[data-cart-tos-error]');

    if ($checkbox.length < 1) {
      return true;
    }

    if ($checkbox.is(':checked')) {
      this.clearTosError($form);
      return true;
    }

    $checkbox.attr('aria-invalid', 'true');
    $error.removeClass('cart-v2-hidden');

    const checkboxNode = $checkbox.get(0);
    if (checkboxNode && typeof checkboxNode.scrollIntoView === 'function') {
      checkboxNode.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }

    return false;
  },
  clearTosError: function ($form) {
    if (!$form || $form.length < 1) {
      return;
    }

    const $checkbox = $form.find('[data-cart-tos]');
    const $error = $form.find('[data-cart-tos-error]');
    $checkbox.removeAttr('aria-invalid');
    $error.addClass('cart-v2-hidden');
  },
  addUpsell: function ($button) {
    if (!$button || $button.length < 1 || $button.hasClass('is-loading') || $button.is(':disabled')) {
      return;
    }

    const variantId = parseInt($button.data('variant-id'), 10);
    if (!variantId) {
      return;
    }

    const self = this;
    const defaultLabel = $button.data('label-default') || '+ Add to setup';
    const addedLabel = $button.data('label-added') || 'Added';
    const $qtyInput = $button.closest('.cart-v2-upsell').find('[data-cart-upsell-qty]').first();
    let quantity = 1;
    if ($qtyInput.length > 0) {
      const selectedQuantity = parseInt($qtyInput.val(), 10);
      if (selectedQuantity && selectedQuantity > 0) {
        quantity = selectedQuantity;
      }
    }

    $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: { id: variantId, quantity: quantity },
      dataType: 'json',
      beforeSend: function () {
        $button.addClass('is-loading').attr('disabled', true).text('Adding...');
      },
      success: function (addedItem) {
        self.trackUpsellAdd(addedItem);
        if ($qtyInput.length > 0) {
          $qtyInput.prop('disabled', false).removeAttr('disabled');
        }
        $button.removeClass('is-loading').addClass('is-added').attr('disabled', true).text(addedLabel);

        if (typeof window.PXUTheme.jsAjaxCart !== 'undefined') {
          window.PXUTheme.jsAjaxCart.updateView();
        }

        window.PXUTheme.jsCart.updateView();
      },
      error: function () {
        if ($qtyInput.length > 0) {
          $qtyInput.prop('disabled', false).removeAttr('disabled');
        }
        $button.removeClass('is-loading').attr('disabled', false).text(defaultLabel);
      }
    });
  },
  updateUpsell: function ($button) {
    if (!$button || $button.length < 1 || $button.hasClass('is-loading') || $button.is(':disabled')) {
      return;
    }

    const lineID = $button.data('line-item-key');
    const $qtyInput = $button.closest('.cart-v2-upsell').find('[data-cart-upsell-qty]').first();
    const quantity = parseInt($qtyInput.val(), 10);
    if (!lineID || !quantity || quantity < 1) {
      return;
    }

    const self = this;
    const defaultLabel = $button.data('label-default') || 'Update quantity';

    $.ajax({
      type: 'POST',
      url: '/cart/change.js',
      data: { line: lineID, quantity: quantity },
      dataType: 'json',
      beforeSend: function () {
        $button.addClass('is-loading').attr('disabled', true).text('Updating...');
      },
      success: function (cart) {
        $qtyInput.prop('disabled', false).removeAttr('disabled');
        self.updateView(cart);

        if (typeof window.PXUTheme.jsAjaxCart !== 'undefined') {
          window.PXUTheme.jsAjaxCart.updateView();
        }
      },
      error: function () {
        $qtyInput.prop('disabled', false).removeAttr('disabled');
        $button.removeClass('is-loading').attr('disabled', false).text(defaultLabel);
      }
    });
  },
  removeFromCart: function (lineID) {
    const $cartItem = window.PXUTheme.jsCart.$section.find(`[data-line-item="${lineID}"]`);

    if ($cartItem.length > 0) {
      $cartItem.css('opacity', '0.5');
    }

    $.ajax({
      type: 'POST',
      url: '/cart/change.js',
      data: 'quantity=0&line=' + lineID,
      dataType: 'json',
      success: function (cart) {
        window.PXUTheme.jsCart.updateView(cart, lineID);

        if (typeof window.PXUTheme.jsAjaxCart !== 'undefined') {
          window.PXUTheme.jsAjaxCart.updateView();
        }
      },
      error: function (XMLHttpRequest, textStatus) {
        var response = eval('(' + XMLHttpRequest.responseText + ')');
        response = response.description;
      }
    });
  },
  replaceCartContent: function (callback) {
    $.ajax({
      cache: false,
      dataType: 'html',
      url: '/cart',
      success: function (html) {
        const $html = $('<div />').append($.parseHTML(html));
        const $updatedCartForm = $html.find('.cart__form').first();
        const $updatedEmptyMessage = $html.find('.cart__empty-cart-message').first();
        const affirmBlock = window.PXUTheme.jsCart.getAffirmCartPromoBlock();

        if ($updatedCartForm.length > 0) {
          $('.cart__form').replaceWith($updatedCartForm);
        }

        if ($updatedEmptyMessage.length > 0) {
          $('.cart__empty-cart-message').replaceWith($updatedEmptyMessage);
        }

        if (affirmBlock) {
          window.PXUTheme.jsCart.affirmCartPromoBlock = affirmBlock;
        }
        window.PXUTheme.jsCart.rehomeAffirmCartPromo();

        if (window.PXUTheme.currencyConverter) {
          window.PXUTheme.currencyConverter.convertCurrencies();
        }

        if (typeof callback === 'function') {
          callback($updatedCartForm);
        }
      }
    });
  },
  syncMobileTotal: function () {
    $('[data-cart-v2-root]').each(function () {
      const $root = $(this);
      const total = $root.find('.cart-v2-total-final').first().text().trim();

      if (total) {
        $root.find('.cart-v2-mobile-total-value').text(total);
      }
    });
  },
  getCartRoot: function () {
    return $('[data-cart-v2-root]').first();
  },
  getCartContext: function () {
    const $root = this.getCartRoot();
    const frameType = ($root.data('cartFrameType') || 'none').toString();
    const currency = ($root.data('cartCurrency') || 'AUD').toString();
    const postcode = this.getPostcode();
    const dispatchEta = this.getDispatchEtaContext();
    return {
      frameType,
      currency,
      postcode,
      shippingSegmentEstimated: this.estimateShippingSegment(postcode),
      dispatchEta
    };
  },
  getPostcode: function () {
    const $root = this.getCartRoot();
    const rootPostcode = ($root.data('cartPostcode') || '').toString().trim();
    const inputPostcode = $('input[name="address[zip]"], #address_zip').first().val();
    const postcodeRaw = rootPostcode || (inputPostcode || '').toString().trim();
    const postcode = postcodeRaw.replace(/[^\d]/g, '').slice(0, 4);
    return postcode;
  },
  estimateShippingSegment: function (postcode) {
    if (!postcode || postcode.length !== 4) {
      return 'unknown';
    }

    const code = parseInt(postcode, 10);
    if (Number.isNaN(code)) {
      return 'unknown';
    }

    const metroRanges = [
      [3000, 3207], // Melbourne metro (approx)
      [4000, 4179], // Brisbane metro (approx)
      [6000, 6214]  // Perth metro (approx)
    ];

    for (let i = 0; i < metroRanges.length; i += 1) {
      if (code >= metroRanges[i][0] && code <= metroRanges[i][1]) {
        return 'metro_estimated';
      }
    }

    return 'regional_estimated';
  },
  getDispatchEtaContext: function () {
    const panel = document.querySelector('[data-dispatch-eta-cart]');
    if (!panel) {
      return {
        stateCode: '',
        stateName: '',
        rule: '',
        headline: '',
        details: ''
      };
    }

    const select = panel.querySelector('[data-dispatch-eta-state]');
    const option = select && select.options ? select.options[select.selectedIndex] : null;
    const headline = option && option.dataset.headline
      ? option.dataset.headline
      : (panel.dataset.generalHeadline || '');
    const details = option && option.dataset.details
      ? option.dataset.details
      : (panel.dataset.generalDetails || '');

    return {
      stateCode: select ? (select.value || '') : '',
      stateName: option && option.dataset.stateName ? option.dataset.stateName : '',
      rule: option && option.dataset.rule ? option.dataset.rule : 'general',
      headline,
      details
    };
  },
  syncDispatchEta: function () {
    const panel = document.querySelector('[data-dispatch-eta-cart]');
    if (!panel) {
      return null;
    }

    const context = this.getDispatchEtaContext();
    const label = context.headline.replace(/^Backorder - estimated (?:shipping|dispatch) (?:starts from|date)\s*/i, '');
    const banner = `${context.headline}${context.details ? `. ${context.details}` : ''}`;

    const headlineOutput = panel.querySelector('[data-dispatch-eta-output-headline]');
    const detailsOutput = panel.querySelector('[data-dispatch-eta-output-details]');
    const stateNameInput = panel.querySelector('[data-dispatch-eta-state-name-input]');
    const headlineInput = panel.querySelector('[data-dispatch-eta-headline-input]');
    const detailsInput = panel.querySelector('[data-dispatch-eta-details-input]');
    const ruleInput = panel.querySelector('[data-dispatch-eta-rule-input]');
    const labelInput = panel.querySelector('[data-dispatch-eta-label-input]');
    const bannerInput = panel.querySelector('[data-dispatch-eta-banner-input]');

    if (headlineOutput) headlineOutput.textContent = context.headline;
    if (detailsOutput) detailsOutput.textContent = context.details;
    if (stateNameInput) stateNameInput.value = context.stateName;
    if (headlineInput) headlineInput.value = context.headline;
    if (detailsInput) detailsInput.value = context.details;
    if (ruleInput) ruleInput.value = context.rule;
    if (labelInput) labelInput.value = label;
    if (bannerInput) bannerInput.value = banner;

    return Object.assign({}, context, { label, banner });
  },
  saveDispatchEtaAttributes: function () {
    const context = this.syncDispatchEta();
    if (!context || !context.headline) {
      return Promise.resolve(null);
    }

    return fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({
        attributes: {
          'Backorder Dispatch ETA': context.headline,
          'Backorder Dispatch ETA Details': context.details || '',
          'Backorder Date Shown': context.label || '',
          'Backorder ETA Shown To Customer': context.banner || ''
        }
      })
    }).catch(function () {});
  },
  detectExpressProvider: function ($el) {
    const text = ($el.text() || '').toLowerCase();
    const className = ($el.attr('class') || '').toLowerCase();
    const id = ($el.attr('id') || '').toLowerCase();
    const fingerprint = `${text} ${className} ${id}`;

    if (fingerprint.indexOf('shop pay') >= 0 || fingerprint.indexOf('shopify-pay') >= 0 || fingerprint.indexOf('shop-pay') >= 0) {
      return 'shop_pay';
    }
    if (fingerprint.indexOf('google pay') >= 0 || fingerprint.indexOf('g pay') >= 0 || fingerprint.indexOf('gpay') >= 0 || fingerprint.indexOf('google-pay') >= 0) {
      return 'google_pay';
    }
    if (fingerprint.indexOf('apple pay') >= 0 || fingerprint.indexOf('apple-pay') >= 0) {
      return 'apple_pay';
    }
    return 'unknown';
  },
  buildCartItems: function (cart) {
    if (!cart || !Array.isArray(cart.items)) {
      return [];
    }

    return cart.items.map(function (item) {
      return {
        item_id: item.product_id,
        item_name: item.product_title || item.title,
        item_variant: item.variant_title,
        item_brand: item.vendor,
        item_category: item.product_type,
        price: (item.final_price || 0) / 100,
        quantity: item.quantity
      };
    });
  },
  buildCartSignature: function (cart) {
    if (!cart || !Array.isArray(cart.items)) {
      return '';
    }

    const keyParts = cart.items.map(function (item) {
      return `${item.key}:${item.quantity}:${item.final_line_price}`;
    });
    return `${cart.item_count}|${cart.total_price}|${keyParts.join('|')}`;
  },
  trackEvent: function (eventName, payload) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push($.extend({ event: eventName }, payload || {}));
  },
  buildTrackingPayload: function (cart, extraPayload) {
    const context = this.getCartContext();
    const items = this.buildCartItems(cart);
    const payload = {
      cart_frame_type: context.frameType,
      shipping_postcode: context.postcode || '',
      shipping_segment_estimated: context.shippingSegmentEstimated,
      shipping_state: context.dispatchEta.stateCode || '',
      backorder_eta_rule: context.dispatchEta.rule || '',
      backorder_eta: context.dispatchEta.headline || '',
      ecommerce: {
        currency: (cart && cart.currency) || context.currency || 'AUD',
        value: cart ? (cart.total_price || 0) / 100 : 0,
        items
      }
    };

    return $.extend(payload, extraPayload || {});
  },
  trackViewCart: function (cart) {
    const signature = this.buildCartSignature(cart);
    if (!signature || signature === this.lastViewCartSignature) {
      return;
    }

    this.lastViewCartSignature = signature;
    this.trackEvent('view_cart', this.buildTrackingPayload(cart, { cart_source: 'cart_page' }));
  },
  trackUpsellAdd: function (addedItem) {
    if (!addedItem) {
      return;
    }

    const context = this.getCartContext();
    const itemPrice = ((addedItem.final_price || addedItem.price) || 0) / 100;

    this.trackEvent('add_to_cart', {
      cart_source: 'cart_upsell',
      cart_frame_type: context.frameType,
      shipping_postcode: context.postcode || '',
      shipping_segment_estimated: context.shippingSegmentEstimated,
      shipping_state: context.dispatchEta.stateCode || '',
      backorder_eta_rule: context.dispatchEta.rule || '',
      ecommerce: {
        currency: context.currency || 'AUD',
        value: itemPrice,
        items: [{
          item_id: addedItem.product_id || addedItem.id,
          item_name: addedItem.product_title || addedItem.title,
          item_variant: addedItem.variant_title,
          item_brand: addedItem.vendor,
          item_category: addedItem.product_type,
          price: itemPrice,
          quantity: addedItem.quantity || 1
        }]
      }
    });
  },
  trackBeginCheckout: function (checkoutType, provider) {
    const cart = this.lastCartState || null;
    this.trackEvent('begin_checkout', this.buildTrackingPayload(cart, {
      checkout_type: checkoutType || 'standard',
      express_provider: provider || 'none'
    }));
  },
  trackExpressCheckout: function (provider) {
    const context = this.getCartContext();
    this.trackEvent('express_checkout_click', {
      cart_frame_type: context.frameType,
      shipping_postcode: context.postcode || '',
      shipping_segment_estimated: context.shippingSegmentEstimated,
      shipping_state: context.dispatchEta.stateCode || '',
      backorder_eta_rule: context.dispatchEta.rule || '',
      express_provider: provider || 'unknown'
    });
  },
  refreshCartSnapshot: function (options) {
    const self = this;
    $.ajax({
      type: 'GET',
      url: '/cart.js',
      dataType: 'json',
      cache: false,
      success: function (cart) {
        self.lastCartState = cart;
        if (options && options.trackView) {
          self.trackViewCart(cart);
        }
      }
    });
  },
  updateView: function (cart) {
    this.replaceCartContent(function ($updatedCartForm) {
      let itemCount = null;
      if ($updatedCartForm && $updatedCartForm.length > 0) {
        itemCount = parseInt($updatedCartForm.attr('data-cart-item-count'), 10);
      }

      if (Number.isNaN(itemCount) || itemCount === null) {
        itemCount = cart && typeof cart.item_count === 'number' ? cart.item_count : 0;
      }

      if (itemCount > 0) {
        $('[data-ajax-cart-trigger]').addClass('has-cart-count');
        $('[data-bind="itemCount"]').text(itemCount);
      } else {
        $('[data-ajax-cart-trigger]').removeClass('has-cart-count');
        $('[data-bind="itemCount"]').text('0');
      }

      window.PXUTheme.jsCart.syncMobileTotal();
      window.PXUTheme.jsCart.collapseMobileDefaults();
      window.PXUTheme.jsCart.updateStickyOffset();
      window.PXUTheme.jsCart.updateSummaryStickyMode();
      window.PXUTheme.jsCart.setupMobileCheckoutHandoff();
      window.PXUTheme.jsCart.setupAffirmCartPromo();
      window.PXUTheme.jsCart.syncDispatchEta();
      window.PXUTheme.jsCart.refreshCartSnapshot({ trackView: true });

      // Bold:POv2
      if (window.BOLD && BOLD.common && BOLD.common.eventEmitter &&
          typeof BOLD.common.eventEmitter.emit === 'function') {
        BOLD.common.eventEmitter.emit('BOLD_COMMON_cart_loaded');
      }
      // Bold:POv2
    });
  },
  unload: function ($section) {
    if (this.mobileCheckoutObserver && typeof this.mobileCheckoutObserver.disconnect === 'function') {
      this.mobileCheckoutObserver.disconnect();
      this.mobileCheckoutObserver = null;
    }
    if (this.mobileHandoffListener) {
      window.removeEventListener('scroll', this.mobileHandoffListener);
      window.removeEventListener('orientationchange', this.mobileHandoffListener);
      this.mobileHandoffListener = null;
    }
    if (this.affirmCartPromoObserver && typeof this.affirmCartPromoObserver.disconnect === 'function') {
      this.affirmCartPromoObserver.disconnect();
      this.affirmCartPromoObserver = null;
    }
    $(document).off(this.namespace);
    $(window).off('resize' + this.namespace);
  }
}

/******/ })()
;
